export default __webpack_public_path__ + "static/media/arpeggio.06483b46.mp3";